import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ReportExportationService } from '../services/report-exportation.service';
import { FileOption } from '../models/file-option.model';
import { MatBottomSheetRef } from '@angular/material';

@Component({
  selector: 'app-bottom-sheet-download-options',
  templateUrl: './bottom-sheet-download-options.component.html',
  styleUrls: ['./bottom-sheet-download-options.component.css']
})
export class BottomSheetDownloadOptionsComponent implements OnInit {

  @Output() onSelected: EventEmitter<FileOption> = new EventEmitter<FileOption>();

  options: Array<FileOption> = [];

  constructor(private bottomSheetRef: MatBottomSheetRef<BottomSheetDownloadOptionsComponent>,
    private exportService: ReportExportationService) { }

  ngOnInit() {
    this.options = this.exportService.getExtensionsOptions();
  }


  onFormatSelected(option: FileOption) {
    this.onSelected.emit(option);

    this.bottomSheetRef.dismiss();
  }
}
